<template>
    <div  class="mcontent">
    <layout
      v-if="root.device!='phone'"
      type="L_R"
              :class="[root.device=='ipad'&&'mipad']"
    >
      <layout
        type="T_B"
        flex="1">
        <wrapper flex='1'>
           <cusbox
             txt="年度退货次品占比">
              <char1 v-if="char1dataShow" :data="char1data" :datelist="datelist" />
              <dv-loading v-else>Loading...</dv-loading>
            </cusbox>
        </wrapper>
        <wrapper  flex='1'>
           <cusbox
             txt="面料质检跟踪（模拟）">
             <layout type="L_R">
               <layout type="T_B">
                 <itemlist
                  :count='10'
                  :columns='columns1'
                  :data='data1'
                >
                 </itemlist>
               </layout>
             </layout>
            </cusbox>
        </wrapper>
        
      </layout>
      <layout
        type="T_B"
        flex="2">
          <wrapper  flex='1'>
           <cusbox
             txt="质检总体概览（模拟）">
              <layout type="L_R">
                 <layout type="T_B" flex="1.5">
                   <div style="display:flex">
                     <div style="width:1vw;"></div>
                      <mycol
                      title="待检成衣件数"
                      value="50"
                      :flex="1"
                      ></mycol>
                      <div style="width:1vw;"></div>
                      <mycol
                        title="已检成衣件数"
                        value="50"
                        :flex="1"
                      ></mycol>
                      <div style="width:1vw;"></div>
                      <mycol
                        title="入库成衣件数"
                        value="50"
                        :flex="1"
                      ></mycol>
                   </div>
                   <div style="display:flex">
                     <div style="width:1vw;"></div>
                      <mycol
                    title="待入库成衣件数"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="退返成衣件数"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="待检面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                   </div>
                   <div style="display:flex">
                     <div style="width:1vw;"></div>
                      <mycol
                    title="已待检面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="已入库面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="不合格,待处理面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                   </div>

                   <div style="height:1vw;"></div>
               </layout>
               <layout type="T_B">
                 <char2
                :data="char2data"
                :rd="['30%', '50%']"
                :txt_show="false"
                title="退货质量问题占比"
              /> 
               </layout>
              </layout>
              
            </cusbox>
        </wrapper>
        <wrapper  flex='1'>
           <cusbox
             txt="成衣质检跟踪（模拟）">
             <layout type="L_R">
               <layout type="T_B">
                 <itemlist
              :count='10'
              :columns='columns2'
              :data='data2'
            />
               </layout>
             </layout>
            </cusbox>
        </wrapper>

      </layout>
      <layout
        type="T_B"
        flex="1">
        <wrapper>
          <cusbox txt="主要退货质量问题分析">
            <layout type="L_R" flex="1" v-if="JSON.stringify(analysisOfMainReturnQualityProblemsValue)!='{}'">
             <layout type="T_B">
                <layout type="L_R" >
                  <div style="width:1vw;"></div>
                  <mycol
                    title="待检退货件数"
                    :value="analysisOfMainReturnQualityProblemsValue.waittingCheck+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="已检退货件数"
                    :value="analysisOfMainReturnQualityProblemsValue.checkedNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                </layout>
               
                <layout type="L_R">
                  <div style="width:1vw;"></div>
                  <mycol
                    title="今日入退货仓件数"
                    :value="analysisOfMainReturnQualityProblemsValue.receiptNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="今日已检退货件数"
                    :value="analysisOfMainReturnQualityProblemsValue.checkedReturnNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                </layout>
                <layout type="L_R">
                  <div style="width:1vw;"></div>
                  <mycol
                    title="扣罚退货件数"
                    :value="analysisOfMainReturnQualityProblemsValue.fineNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="扣罚比例"
                   :value="analysisOfMainReturnQualityProblemsValue.fineRate+'%'"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                </layout>
             </layout>
            </layout>
             <dv-loading v-else>Loading...</dv-loading>
            <layout type="L_R" flex="1">
                <char2
                    v-if="JSON.stringify(char2data2)!='[]'"
                    :data="char2data2"
                    :rd="['20%', '45%']"
                    title="退货质量问题占比"
                  />
            </layout>
          </cusbox>
        </wrapper>
      </layout>
    </layout>



            <mobile class="device_phone ppd notransform" v-else>
                <div  style="height:400px;margin-top:10px;">
                    <cusbox
                    txt="质检总体概览（模拟）">
    
                 <layout type="T_B" style="height:150px;flex:none">
                   <div style="display:flex"  flex='1'>
                     <div style="width:1vw;"></div>
                      <mycol
                      title="待检成衣件数"
                      value="50"
                      :flex="1"
                      ></mycol>
                      <div style="width:1vw;"></div>
                      <mycol
                        title="已检成衣件数"
                        value="50"
                        :flex="1"
                      ></mycol>
                      <div style="width:1vw;"></div>
                      <mycol
                        title="入库成衣件数"
                        value="50"
                        :flex="1"
                      ></mycol>
                   </div>
                   <div style="display:flex"  flex='1'>
                     <div style="width:1vw;"></div>
                      <mycol
                    title="待入库成衣件数"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="退返成衣件数"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="待检面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                   </div>
                   <div style="display:flex"  flex='1'>
                     <div style="width:1vw;"></div>
                      <mycol
                    title="已待检面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="已入库面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="不合格,待处理面辅料"
                    value="50"
                    :flex="1"
                  ></mycol>
                   </div>

                   <div style="height:1vw;"></div>
               </layout>
               <layout type="T_B">
                 <char2
                :data="char2data"
                :rd="['50%', '70%']"
                :txt_show="false"
                title="退货质量问题占比"
              /> 
               </layout>
           
              
            </cusbox>
                </div>
                 <div  style="height:250px;margin-top:10px;">
                     <cusbox
                      txt="年度退货次品占比">
                        <char1 v-if="char1dataShow" :data="char1data" :datelist="datelist" />
                         <dv-loading v-else>Loading...</dv-loading>
                      </cusbox>
                       
                 </div>
                 <div style="height:400px;margin-top:10px;">
                     <cusbox
                    txt="面料质检跟踪（模拟）">
                    <layout type="L_R">
                      <layout type="T_B">
                        <itemlist
                          :count='10'
                          :columns='cols_1'
                          :data='data1'
                        >
                        </itemlist>
                      </layout>
                    </layout>
                    </cusbox>
                 </div>
                 <div  style="height:400px;margin-top:10px;">
                     <cusbox txt="主要退货质量问题分析">
            <layout type="L_R" flex="1" v-if="JSON.stringify(analysisOfMainReturnQualityProblemsValue)!='{}'">
             <layout type="T_B">
                <layout type="L_R">
                  <div style="width:1vw;"></div>
                  <mycol
                    title="待检退货件数"
                     :value="analysisOfMainReturnQualityProblemsValue.waittingCheck+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="已检退货件数"
                     :value="analysisOfMainReturnQualityProblemsValue.checkedNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                </layout>
                <layout type="L_R">
                  <div style="width:1vw;"></div>
                  <mycol
                    title="今日入退货仓件数"
                    :value="analysisOfMainReturnQualityProblemsValue.receiptNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="今日已检退货件数"
                    :value="analysisOfMainReturnQualityProblemsValue.checkedReturnNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                </layout>
                <layout type="L_R">
                  <div style="width:1vw;"></div>
                  <mycol
                    title="扣罚退货件数"
                    :value="analysisOfMainReturnQualityProblemsValue.fineNum+''"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                  <mycol
                    title="扣罚比例"
                    :value="analysisOfMainReturnQualityProblemsValue.fineRate||0+'%'"
                    :flex="1"
                    height="7vw"
                  ></mycol>
                  <div style="width:1vw;"></div>
                </layout>
             </layout>
            </layout>
            <dv-loading v-else>Loading...</dv-loading>
            <layout type="L_R" flex="5">
                <char2
                    v-if="JSON.stringify(char2data2)!='[]'"
                    :data="char2data2"
                    :rd="['20%', '60%']"
                    title="退货质量问题占比"
                  />
            </layout>
          </cusbox>
                 </div>
                 <div  style="height:450px;margin-top:10px;">
                   <cusbox
                    txt="成衣质检跟踪（模拟）">
                    <layout type="L_R">
                      <layout type="T_B">
                        <itemlist
                          :count='10'
                          :columns='cols_2'
                          :data='data2'
                        >
                        </itemlist>
                      </layout>
                    </layout>
                    </cusbox>
                 </div>
            </mobile>
    </div>
</template>
<script>
import layout from "@/components/cuscom/layout.vue";
import wrapper from "@/components/cuscom/wrapper.vue";
import cusbox from "@/components/vip/cusbox";
import itemlist from "@/components/cuscom/itemlist";
import char1 from "./report/char1.vue";
import char2 from "./report/char2.vue";
import mycol from "./report/vancol.vue";
import {cols_1,cols_2} from "./device/phone_column.js"
export default {
   inject:['root'],
  components: { layout, wrapper, cusbox, itemlist, char1, char2, mycol },
  data() {
    return {
      analysisOfMainReturnQualityProblemsValue:{},
      cols_1,
      cols_2,
      api:this.$apis["quality_testing"],
      columns1: [
        {
          title: "验货单",
          key: "order",
          align: "center",
        },
        {
          title: "入品控仓日期",
          key: "date",
          align: "center"
        },
        {
          title: "类型",
          key: "type",
          align: "center"
        },
        {
          title: "单据状态",
          key: "status",
          align: "center"
        }
      ],
      columns2: [
        {
          title: "验货单",
          key: "inspection_list",
          align: "center",
          width: "5vw"
        },
        {
          title: "入品控仓日期",
          key: "quality_control_date",
          align: "center",
          width: "5vw"
        },
        {
          title: "类型",
          key: "type",
          align: "center"
        },
        {
          title: "单据状态",
          key: "order_status",
          align: "center",
          width: "7vw"
        },
        {
          title: "待检数",
          key: "be_inspected_number",
          align: "center"
        },
        {
          title: "已检数",
          key: "inspected_number",
          align: "center"
        },
        {
          title: "合格数",
          key: "qualified_number",
          align: "center"
        },
        {
          title: "入库数",
          key: "warehousing_number",
          align: "center"
        },
        {
          title: "退返数",
          key: "return_number",
          align: "center"
        }
      ],
      data1: [],
      data2: [],
      char2data: [
        {
          value: 20,
          name: "欠配饰",
          itemStyle: { color: "#8943D3" },
          showvalue: "25%"
        },
        {
          value: 25,
          name: "口袋有异物",
          itemStyle: { color: "#EACD2C" },
          showvalue: "25%"
        },
        {
          value: 25,
          name: "脏污",
          itemStyle: { color: "#4346D3" },
          showvalue: "25%"
        },
        {
          value: 25,
          name: "抽纱",
          itemStyle: { color: "#43D3C9" },
          showvalue: "25%"
        },
        {
          value: 25,
          name: "欠吊牌",
          itemStyle: { color: "#6648FF" },
          showvalue: "25%"
        }
      ],
      char2data2:[],
      char1data:{},
      char1dataShow:false,
      datelist:[]
    };
  },
  mounted() {
    let that =this 
     this.api.proportionOfReturnQualityProblems().then(res=>{
      if(res.data.list){
        let arr =[]
        for(var i =0;i<res.data.list.length;i++){
          arr.push({
            value:res.data.list[i].problemRate,
            name:res.data.list[i].problemName,
            itemStyle: { color:i==1?"#8943D3":i==2?"#EACD2C":i==3?"#4346D3":i==4? "#43D3C9": "#6648FF"  },
            showvalue: res.data.list[i].problemRate+"%"
          })
        }
        this.char2data2 =arr
      }
    })
    this.api.proportionOfDefectiveProductsReturned().then(res=>{
      // this.char1data
      var obj={date:[],substandard:[],return:[]}
      for(var i=0;i<res.data.list.length;i++){
        obj.date.push(res.data.list[i].time+'月')
        obj.substandard.push(res.data.list[i].problemNum)
        obj.return.push(res.data.list[i].returnNum)
      }
      this.char1dataShow = true
      setTimeout(function(){
        that.char1data=obj
      that.datelist=obj.date
      },0)     
    })
    this.api.analysisOfMainReturnQualityProblems().then(res=>{
      this.analysisOfMainReturnQualityProblemsValue = res.data
    })
    
  
    this.api.get2().then(res=>{
      this.data1=res.data.list
    })
    this.api.get3().then(res=>{
      this.data2=res.data.list
    })
  }
};
</script>
<style lang="scss" scoped>
.mcontent {
  color: #fff;
  height: 100%;
  display: flex;
 }
</style>

